import { initializeOrderState, IError } from '../state/app.state';
import { createReducer, on, Action } from '@ngrx/store';
import * as fromOrderAction from '../action/order.action';
import { Identifiers } from '@angular/compiler';
import { IOrderData } from '@app/@shared/Models/order.model';

export const initialOrderState: IOrderData = initializeOrderState();

const reducer = createReducer(
    initialOrderState,
    on(fromOrderAction.GetOrderdItemsSuccess, (state: IOrderData, { payload }) => {
        return { ...state, OrderResponse: payload };
    }),
    on(fromOrderAction.GetOrderdItemError, (state, { payload }
    ) => {
        return { ...state, error: payload };
    })
);

export function OrderReducer(state: IOrderData | undefined, action: Action) {
    return reducer(state, action);
}  